exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".LanguageChooser__icon {\n  display: inline-block;\n  cursor: pointer;\n  margin: 0 2.5px;\n  width: 25px;\n  height: 25px; }\n", ""]);

